// extracted by mini-css-extract-plugin
export default {"discountsTab":"style--discountsTab--1fa5d5","title":"style--title--955bbc","heading":"style--heading--85314d"};